module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-GB"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Keep your strength")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Keep your strength my little girl ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Keep your strength")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Lose it not, keep your strength")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Listening to my advice, to my voice")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Do not give it away, keep your strength")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("As a young sweet and tender flower")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("You know not the meaning of such treasure")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("You will know its priceless value")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Listening to no hungry fool")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Keep your blood, keep your strength")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8588f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398406179_EPUB6.vue
// module id = 75
// module chunks = 0